/**
 * As duas letras do avatar: "Theo Restivo" → "TR".
 *
 * <p>Estava copiada em <b>onze</b> arquivos, em duas variantes — e uma delas produzia
 * lixo visível. `nome.split(' ')` num nome com espaço sobrando devolve uma parte vazia:
 *
 * <pre>
 *   " Theo Restivo".split(' ')  →  ["", "Theo", "Restivo"]
 *   p[0][0]                     →  undefined
 *   (undefined + "T").toUpperCase()  →  "UNDEFINEDT"
 * </pre>
 *
 * <p>O avatar mostrava literalmente <b>UNDEFINEDT</b>. E "Theo  Restivo", com dois
 * espaços, virava só "T". Nenhum dos dois estoura — por isso durou: o defeito aparece na
 * tela e não no console, e depende de um dado que ninguém digita de propósito.
 *
 * <p>Aqui as partes vazias são descartadas antes de qualquer coisa, e nome sem letra
 * nenhuma devolve um travessão em vez de "UNDEFINED".
 *
 * <p><b>Segunda letra é a da segunda palavra</b>, e não a da última: "André Luiz Aponte"
 * dá "AL". É o que as onze cópias faziam, e mudar para "AA" trocaria a inicial de metade
 * do time sem ninguém ter pedido.
 */
export function iniciais(nome: string | null | undefined): string {
  const partes = (nome ?? '').trim().split(/\s+/).filter(Boolean);
  if (partes.length === 0) return '—';
  return (partes[0][0] + (partes[1]?.[0] ?? '')).toUpperCase();
}

/**
 * Só o primeiro nome: "Theo Restivo" → "Theo".
 *
 * <p>Mora ao lado de {@link iniciais} porque erra do mesmo jeito. `nome.split(' ')[0]`
 * num nome com espaço sobrando devolve **string vazia**, e a frase que o usava virava
 * "Só  (ou um admin) pode editar estas horas" — sem o nome de ninguém.
 */
export function primeiroNome(nome: string | null | undefined): string {
  return (nome ?? '').trim().split(/\s+/).filter(Boolean)[0] ?? '';
}
